import { map } from 'ramda';

export const objectView = propMap => state => map(view => view(state), propMap);


